import { Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import Dashboard from '../pages/StudentDashboard/Dashboard.js';
import Applications from '../pages/ReveiwerDashboard/Applications.js';
import EditProfile from '../components/EditProfile/index.js';
import Layout from "../layout/index.js";
import ReimbursementAmount from "../pages/VendorDashboard/Reimbursement.js";
import Staff from "../pages/VendorDashboard/Staff.js";
import ChangePassword from "../components/ChangePassword/index.js";

const routes = [
  { path: "", element: <Dashboard />, text: "Dashboard" },
  { path: "application", element: <Applications role="vendor"/>, text: "Review Applications" },
  { path: "my-reimbursement", element: <ReimbursementAmount />, text: "My Reimbursement" },
];

// Only the parent partner manages staff; staff users don't see this page.
const staffRoute = { path: "staff", element: <Staff />, text: "Manage Staff" };

const VendorRoutes = () => {
  const userdetail = useSelector((state) => state.mainSlice.userdetail);
  const navItems = userdetail?.parentVendor ? routes : [...routes, staffRoute];

  return (
    <Routes>
      <Route path="/" element={<Layout navItems={navItems} />}>
        {navItems.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route path="/edit-profile" element={<EditProfile />} />
        <Route path="/change-password" element={<ChangePassword />} />
      </Route>
    </Routes>
  );
};

export default VendorRoutes;
